import { Trash2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import {
  BaseEdge,
  EdgeLabelRenderer,
  getStraightPath,
  useReactFlow,
  type EdgeProps
} from '@xyflow/react';

import { useCategoryFlowActions } from './custom-shop-categories-flow-context.tsx';

/** Arête personnalisée avec bouton de suppression du lien parent-enfant. */
export function CategoryFlowEdge({ id, sourceX, sourceY, targetX, targetY, target }: EdgeProps) {
  const { t } = useTranslation();
  const { deleteElements } = useReactFlow();
  const { canManageCategories, removingChildId, onRemoveParentLink } = useCategoryFlowActions();
  const [edgePath, labelX, labelY] = getStraightPath({
    sourceX,
    sourceY,
    targetX,
    targetY
  });

  const childCategoryId = Number(target);
  const isRemoving = removingChildId === childCategoryId;

  /** Supprime visuellement l'arête puis déclenche le détachement API. */
  const handleDelete = () => {
    deleteElements({ edges: [{ id }] });
    void onRemoveParentLink(childCategoryId);
  };

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        style={{ stroke: 'hsl(var(--foreground) / 0.35)', strokeWidth: 2 }}
      />
      {canManageCategories && (
        <EdgeLabelRenderer>
          <button
            type="button"
            className="flex justify-center items-center rounded-full border shadow-sm transition-colors nodrag nopan size-7 border-border bg-background text-destructive hover:bg-destructive/5 hover:text-destructive disabled:cursor-not-allowed disabled:opacity-50"
            style={{
              position: 'absolute',
              transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
              pointerEvents: 'all',
              zIndex: 1000
            }}
            title={t('admin.shops.categories.detach.aria')}
            disabled={isRemoving}
            onClick={handleDelete}
          >
            <Trash2 className="size-3.5" />
          </button>
        </EdgeLabelRenderer>
      )}
    </>
  );
}
